const NOTIFICATION_CATEGORY = {
  DataSourceNotifications: "DataSourceNotifications",
  ExperimentOperations: "ExperimentOperations",
  ScorecardJobStatus: "ScorecardJobStatus",
  MetricSetNotifications: "MetricSetNotifications"
};
export {
  NOTIFICATION_CATEGORY
};
//# sourceMappingURL=NotificationSettingConstants.js.map
